<style lang="less" scoped>
.ZjDetails {position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 60px;}
.national {width: 1200px;}
.first {width: 100%;height: 300px;border-radius: 5px;background-color:skyblue;margin-bottom: 20px;
  img {width: 100%;height: 300px;}
  .firstbox {margin: 0px auto;width: 256px;position: relative; top: -300px;
    .HeadPortrait {width: 97px;height: 97px;margin: 0px auto;margin-top: 20px;border-radius:50%;background-color: yellow;
      img {width: 100%;height: 100%;border-radius:50%;}}
    .name {	line-height: 32px;letter-spacing: 1px;color: #ffffff;font-size: 18px;}
    .introduce {font-size: 16px;line-height: 32px;letter-spacing: 1px;color: #ffffff;padding: 0;margin: 0;list-style: none;display: flex;justify-content: space-between;align-items: flex-end;margin-bottom: 20px;}
    .btn {display: flex;justify-content: space-between;align-items: flex-end;width: 100%;height: 36px;
      .el-button {font-size: 16px;line-height: 21px;letter-spacing: 0px;color: #707070;	width: 116px;height: 36px;padding: 0;}
      .el-button:hover {color: #409EFF;border-color: #c6e2ff;background-color: #ecf5ff;}
      /deep/ .el-button+.el-button {margin: 0px;}
    }
  }
}
.second {
  ul{list-style: none;margin: 0;padding: 0;}
  .imgTitleContent{text-align: left;}
}
.third {width: 200px;height: 48px;
  .el-button {width: 100%;height: 100%;line-height: 21px;letter-spacing: 0px;color: #707070;font-size: 16px;margin-top: 31px;}
}
</style>
<template>
    <div class="ZjDetails">
      <National></National>
      <div class="first">
        <img src="/static/images/zlkindex/专家背景.png" alt="">
        <div class="firstbox">
          <div class="HeadPortrait">
              <img src="static/images/zlkindex/专家头像.png" alt="">
          </div>
          <p class="name">{{ this.ZJname }}</p>
          <ul class="introduce">
            <li><span>文章数：</span><span>{{ this.ZJdata.length }}</span><span>篇</span></li>
            <li><span>阅读量：</span><span>{{ this.hits }}</span><span>次</span></li>
          </ul>
          <div class="btn">
            <el-button class="new" @click="newsorting()">最新文章</el-button>
            <el-button class="hot" @click="hotsorting()">最热文章</el-button>
          </div>
        </div>
      </div>
      <div class="second">
        <ul>
          <li v-for="(item,index) in items" :key="index" >
            <ZJImgTitleContent class="imgTitleContent" :imgTitleContentItem="item" @handleClick="goDetails"></ZJImgTitleContent>
          </li>
        </ul>
      </div>
      <div class="third">
        <el-button @click="getOthers" :disabled="moreLength <= 0">加载更多</el-button>
      </div>
    </div>
</template>

<script>
import National from '../assembly/National.vue'
import ZJImgTitleContent from '../assembly/ZJImgTitleContent.vue'
import arrayFun from '../method/array.js'
export default {
  components: {
    National,
    ZJImgTitleContent
  },
  data()
  {
    return {
      curID: null,
      imgTitleContentdata: [], //列表页数据
      ZJdata: [],
      ZJname: null,
      items: [],
      num: null,
      hits: null,
      moreLength: null
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.curID = +nval.query.id
        this.getData()
      },
      immediate: true
    }
  },
  methods: {
    getData()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 28, _exp: 'id=? and examine = 0', types: 'i', vals: this.$route.query.id}
      window.post.getPost(paras).then((ret) =>
      {
        this.ZJname = ret[0].truename
        let paras1 = {cmd: 'query', _major: 11, _minor: 45, _exp: 'username=?', types: 's', vals: ret[0].username}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          let arr = []
          ret.forEach(item =>
          {
            temp.push({id: item.id, catid: item.catid, title: item.title, introduce: item.introduce, release: '发布时间', time: item.addtime, description: '关键词', value: item.tag, hits: item.hits})
            arr.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布时间', time: item.addtime, description: '关键词', value: item.tag, hits: item.hits})
            this.hits += item.hits
          })
          this.ZJdata = temp
          this.imgTitleContentdata = arr
          this.moreLength = this.imgTitleContentdata.length
          // 初始化页面数据
          this.items = []
          for (let i = 0; i < 6; i++)
          {
            this.items.push(this.imgTitleContentdata[i])
            this.moreLength -= 1
          }
          this.num = 0
        })
      })
    },
    // 点击加载更多，依次添加6条数据，并重新渲染然页面展示的数据
    getOthers()
    {
      this.num += 1
      if (this.imgTitleContentdata.length - 6 * this.num >= 6)
      {
        for (let i = 0; i < 6; i++)
        {
          this.items.push(this.imgTitleContentdata[i + 6 * this.num])
          this.moreLength -= 1
        }
      }
      else
      {
        for (let i = 0; i < this.imgTitleContentdata.length - 6 * this.num; i++)
        {
          this.items.push(this.imgTitleContentdata[i + 6 * this.num])
          this.moreLength -= 1
        }
      }
    },
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZhikuDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    newsorting()
    {
      this.items.sort(arrayFun.compareBtoS('time'))
    },
    hotsorting()
    {
      this.items.sort(arrayFun.compareBtoS('hits'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZjDetails.vue